import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import { Container, Value, Clock } from './styles'
import { useTimer } from '../../../hooks/useTimer'
import { Image } from '../image'
import { daysToHours } from '../../../utils/datetime'
import TimerAnimation from '../../../images/timer_animation.gif'

export const Timer = ({
  endDate,
  onFinish,
  expiryReminder,
}) => {
  const { days, hours, minutes, seconds } = useTimer({
    endDate,
    onFinish,
  })

  const isExpiring = expiryReminder
    ? Number(expiryReminder) > daysToHours(days) + hours
    : days < 1

  const formatTimerString = (d, h, m, s) => {
    const pad = (v) => String(v).padStart(2, '0')
    const time = `${pad(h)}:${pad(m)}:${pad(s)}`
    return d > 0 ? `${d}d ${time}` : time
  }

  const formattedTime = useMemo(
    () => formatTimerString(days, hours, minutes, seconds),
    [days, hours, minutes, seconds]
  )

  return (
    <Container isExpiring={isExpiring}>
      <Clock>
        <Image url={TimerAnimation} width={'15px'} />
      </Clock>

      {typeof days !== 'undefined' && (
        <Value isExpiring={isExpiring}>{formattedTime}</Value>
      )}
    </Container>
  )
}

Timer.defaultProps = {
  endDate: '',
  onFinish: () => {},
  expiryReminder: null,
}

Timer.propTypes = {
  endDate: PropTypes.string,
  onFinish: PropTypes.func,
  expiryReminder: PropTypes.number,
  $small: PropTypes.bool,
}
